import { useLocation } from "react-router-dom";
import { useAppSelector } from "../app/store";
import { useGetMeQuery } from "../features/auth/authApi";
import { Role } from "../types";

export default function useAuth(roles?: Role[]) {
  const { access_token, role, user } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const { data } = useGetMeQuery(user?.id);
  const { can_download_reports } = data?.data || {};
  const canDownloadReport =
    can_download_reports || role === "Admin" || role === "super_admin";

  // const accessRole = role && roles?.length && roles?.includes(role);
  const paths = location?.pathname?.split("/");
  const isTemplatesPage =
    paths?.includes("all-templates") && !paths?.includes("template-details");
  if (isTemplatesPage && role === "User") {
    return false;
  }
  const isReportsPage = paths?.includes("reports");
  if (isReportsPage && !canDownloadReport) {
    return false;
  }

  // return access_token && user && (roles?.length ? accessRole : true);
  return access_token;
}
